import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import PromotionSelector from "../components/PromotionSelector";
import { NavigationContext, UserContext } from "../contexts";
import { getPageTitle } from "../resources/routes";
import { Promotion } from "../types";
import { scrollToTop } from "../util";

const SpecialOffersScreen = observer(() => {
  const userContext = useContext(UserContext);
  const navContext = useContext(NavigationContext);
  const location = useLocation();

  useEffect(() => {
    scrollToTop();
    navContext.setFooterModePrimary();
    navContext.setNextButtonEnabled(true);

    navContext.setOnNavigateBack(() => {
      // Reset selection when the user goes back
      userContext.setSelectedSpecialOffer(null);
      navContext.setOfferTickerVisible(false);
    });

    return () => {
      navContext.setOfferTickerVisible(false);
    };
  }, []);

  const onClickItem = (item: Promotion) => {
    if (
      userContext.selectedSpecialOffer &&
      userContext.selectedSpecialOffer.id === item.id
    ) {
      if(!item.preselected){
        userContext.setSelectedSpecialOffer(null);
        navContext.setOfferTickerVisible(false);
      }
    } else {
      userContext.setSelectedSpecialOffer(item);
      navContext.setOfferTickerVisible(true);
    }
  };

  return (
    <div className={"screen screen-choose-special-offers"}>
      <div className={"container"}>
        <h2 className="h1"><strong className="number">Step 6:</strong> {getPageTitle(location.pathname)}</h2>
        <p className={"subtitle"}>
          Select our current promotion, available only for a limited time.
        </p>
        <div className="flex-section-label">
          <p className={"section-label"}>Select your Special Offers</p>
          {userContext.selectedSpecialOffer && (
            <p className={"section-label"}>1 Active</p>
          )}
        </div>
      </div>
      <PromotionSelector
        promotions={userContext.specialOffers}
        selectedPromotion={userContext.selectedSpecialOffer}
        onClickPromotion={onClickItem}
      />
    </div>
  );
});

export default SpecialOffersScreen;
